module.exports = __webpack_public_path__ + "static/UnqMikkA-8cc7609fd4bdc44f91a4f73ab783a314.gif";